import { render, staticRenderFns } from "./ProductCardPreview.vue?vue&type=template&id=55bcbea9&scoped=true&"
import script from "./ProductCardPreview.vue?vue&type=script&lang=js&"
export * from "./ProductCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardPreview.vue?vue&type=style&index=0&id=55bcbea9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bcbea9",
  null
  
)

export default component.exports